import { CtaButton, Spinner } from '@zappyrent/hundop';
import { rem } from 'polished';
import styled from 'styled-components/macro';

export const StyledButton = styled(CtaButton).attrs({
  tag: 'button',
  user: 'tenant',
})`
  text-transform: uppercase;
  background-color: ${({ theme }) => theme.colors.main};
  border: none;
  box-shadow: none;
  color: ${({ theme }) => theme.colors.tenant.main};
  margin: ${rem('16px')} 0;
  position: relative;

  &:hover:not(:disabled) {
    background-color: ${({ theme }) => theme.colors.main};
  }
`;

export const StyledSpinner = styled(Spinner)`
  position: absolute;
  right: -${rem('8px')};
  top: 28%;
`;
export const RowContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const StyledButtonWrapper = styled.div`
  display: flex;
  gap: ${rem('10px')};
  align-items: center;
`;
